/*
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import { RequiredAuth } from './SecureRoute';
import DateFnsUtils from '@date-io/date-fns';
import DashboardContainer from './components/DashboardContainer'
import OktaAuthCallback from './components/OktaAuthCallback'
import SolutionDashboard from './components/Soluations/SolutionDashboard'
import FourRisks from './components/Soluations/FourRisks';
import Login from './components/Login'
import BasicDocument from './components/Soluations/BasicDocument';
import Loading from './Loading';
import Registration from './components/Soluations/Registration';

const AppRoutes = () => {
  return (

    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      {/* Below route is added to handle call back received after Okta Authentication */}
      <Route path="/oAuth/callback" element={<OktaAuthCallback />} />
      <Route path="/dashboard" element={<RequiredAuth />}>
        <Route path="" element={<DashboardContainer />} />
      </Route>
      <Route path="/solution" element={<RequiredAuth />}>
        <Route path="" element={<SolutionDashboard />} />
      </Route>
      <Route path="/registration" element={<Registration />}>
        {/* <Route path="" element={<Registration/>}/> */}
      </Route>
      <Route path="/4-risks" element={<RequiredAuth />}>
        <Route path="" element={<FourRisks />} />
      </Route>
      <Route path="/document" element={<RequiredAuth />}>
        <Route path="" element={<BasicDocument />} />
      </Route>
      <Route> 404 Not Found!</Route>
    </Routes>

  );
};

export default AppRoutes;
